import { CREATIVE_TRACKER_V2_API, DSP_PROVIDER_API, GET, POST } from '../constants';
import { jwtTokenHeader, request } from '../utils';

export const getCreativesV2 = async (filterSelected, limit, offset) => {
  const url = `${CREATIVE_TRACKER_V2_API}/search?limit=${limit}&offset=${offset}`;
  return request(POST, url, { ...filterSelected }, await jwtTokenHeader(), 'Fetching Creatives V2 failed.').catch(
    (err) => {
      console.error('Failed to get creatives! ' + err);
    }
  );
};

export const requestFullExport = async (filterSelected) => {
  const url = `${CREATIVE_TRACKER_V2_API}/search/export`;
  return request(POST, url, { ...filterSelected }, await jwtTokenHeader(), 'Requesting full export failed.');
};

export const getContentPartners = async () =>
  request(
    GET,
    `/api/content-partner-provider/metadata/content-partners`,
    {},
    await jwtTokenHeader(),
    'Failed to load content partners.'
  ).catch((err) => {
    console.error('Failed to get content partners! ' + err);
  });

export const getBrandNames = async (payload) => {
  return request(
    POST,
    `${CREATIVE_TRACKER_V2_API}/options/brands`,
    payload,
    await jwtTokenHeader(),
    'Failed to load brand names.'
  ).catch((err) => {
    console.error('Failed to get brand names! ' + err);
  });
};

export const getAllDSPs = async () =>
  request(GET, `${DSP_PROVIDER_API}/dsps`, null, await jwtTokenHeader(), 'Failed to get all DSPs.').catch((err) => {
    console.error('Failed to get all DSPs! ' + err);
  });
